






























import {Component, Vue} from 'vue-property-decorator';
import OrdersTable from '@/screens/dashboard/orders/OrdersTable.vue';
import {Location} from 'vue-router';

@Component({
  components: {
    OrdersTable,
  },
})
export default class OrdersScreen extends Vue {
  get exportTrackingRoute(): Location {
    return {name: 'dashboard.order.export-tracking'};
  }

  get exportExcelFileRoute(): Location {
    return {name: 'dashboard.order.export-to-excel-file'};
  }
}
